import coinbartaImg from '../imgs/coin-barta.png'
import bitBotsImg from '../imgs/bit-bots.png'
import syndesmosImg from '../imgs/syndesmos.png'
import gaoGram from '../imgs/Gao-Gram.png'

export const projects = [
  {
    id: 1,
    name: 'Gao Gram ',
    description:
      'It is an E-Commerce site. actually, The website is under construction. We hope it will be finished by Feb-23 first week.',
    url: 'http://frontend.dev.gaogram.com/',
    img: gaoGram,
  },
  {
    id: 1,
    name: 'Gao Gram Admin',
    description:
      'It is Gao Gram Admin site. actually, The website is under construction. We hope it will be finished by Feb-23 first week.',
    url: 'http://admin.dev.gaogram.com',
    img: gaoGram,
  },

  {
    id: 2,
    name: 'Coin Barta',
    description:
      'It was a news portal website about blockchain. and It is the first website in Bangla that is related to blockchain.',
    url: 'https://coinbarta.com',
    img: coinbartaImg,
  },
  {
    id: 3,
    name: 'Bit-Bots',
    description:
      'It was an E-Commerce site. actually, The client sells games in this site. User can purchase and pay with PayPal.',
    url: 'https://effortless-praline-11b485.netlify.app/',
    img: bitBotsImg,
  },
  {
    id: 4,
    name: 'Syndesmos',
    description:
      'It was a news portal website about blockchain. and It is the first website in Bangla that is related to blockchain.',
    url: 'https://storied-gnome-e87320.netlify.app/',
    img: syndesmosImg,
  },
]
